import React from 'react';
import { StyleSheet } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import { useConsumerStatusSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import {
  AppleCreditStatus,
  HoukatsuStatus,
} from 'apollo/queries/autogenerate/schemas';
import BannerAmazon from 'shared/assets/images/banners/banner-amazon-6pay.png';
import BannerAmazonWeb from 'shared/assets/images/banners/banner-amazon-6pay@3x.png';
import BannerAppleNonPPFA from 'shared/assets/images/banners/banner-apple-non-ppfa.png';
import BannerAppleNonPPFAWeb from 'shared/assets/images/banners/banner-apple-non-ppfa@3x.png';
import BannerApplePPFA from 'shared/assets/images/banners/banner-apple-ppfa.png';
import BannerApplePPFAWeb from 'shared/assets/images/banners/banner-apple-ppfa@3x.png';
import BannerShopping from 'shared/assets/images/banners/banner-shopping.png';
import BannerShoppingWeb from 'shared/assets/images/banners/banner-shopping@3x.png';
import Carousel, {
  Item,
} from 'shared/modules/common/components/molecules/Carousel';
import useIsShoppingEnabled from 'shared/modules/common/hooks/use-is-shopping-enabled';

type Props = {
  onItemPress?: (item: Item) => void;
};

const IS_WEB = process.env.APP_ENV === 'web';

const Banners = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const isHugeScreen = useMediaQuery({ minWidth: 1024 });
  const isExtraHugeScreen = useMediaQuery({ minWidth: 1280 });
  const shopping = useIsShoppingEnabled();
  const { data: consumerSummaryData } = useConsumerStatusSummaryQuery({
    fetchPolicy: 'cache-only',
  });

  const items: Item[] = [];

  // Banner order: Apple > Shop > Amazon > Paidy Link

  // #1 Apple
  const bannerAppleWeb =
    consumerSummaryData?.appleCreditStatus.status === AppleCreditStatus.APPROVED
      ? BannerApplePPFAWeb
      : BannerAppleNonPPFAWeb;
  const bannerApple =
    consumerSummaryData?.appleCreditStatus.status === AppleCreditStatus.APPROVED
      ? BannerApplePPFA
      : BannerAppleNonPPFA;

  items.push({
    id: 'apple',
    imageUri: IS_WEB ? bannerAppleWeb : bannerApple,
    title:
      bannerAppleWeb === BannerApplePPFAWeb ? '購入はこちら' : '今すぐ申し込む',
  });

  // #2 Shopping
  if (shopping) {
    items.push({
      id: 'shopping',
      imageUri: IS_WEB ? BannerShoppingWeb : BannerShopping,
      title: '「お買い物」を見てみる',
    });
  }

  // #3 Amazon
  items.push({
    id: 'amazon',
    imageUri: IS_WEB ? BannerAmazonWeb : BannerAmazon,
    title:
      consumerSummaryData?.houkatsuStatus.status === HoukatsuStatus.APPROVED ||
      consumerSummaryData?.houkatsuStatus.status ===
        HoukatsuStatus.APPROVED_FOR_NLP
        ? '詳しくはこちら'
        : '６回あと払いの詳細を見る',
  });

  // Open Loop requires a bearer token that the Web cannot provide
  // if (paidyLink) {
  //   items.push({
  //     id: 'paidy-link',
  //     imageUri: BannerPaidyLink,
  //     title: 'どこでもペイディの詳細を見る',
  //   })
  // }

  return (
    <Carousel
      items={items}
      style={!isBigScreen && style.carousel}
      numColumns={
        isHugeScreen && items.length > 3
          ? isExtraHugeScreen
            ? 3
            : 2
          : undefined
      }
      onItemPress={props.onItemPress}
      id="banners-carousel"
    />
  );
};

const style = StyleSheet.create({
  carousel: {
    marginHorizontal: -16,
    paddingHorizontal: 16,
  },
});

export default Banners;
